import m from "./ghl-ui.es1506.js";
import f from "./ghl-ui.es1467.js";
import o from "./ghl-ui.es1663.js";
import i from "./ghl-ui.es1466.js";
var u = 6048e5;
function p(t, r) {
  i(1, arguments);
  var e = m(t), a = f(e, r).getTime() - o(e, r).getTime();
  return Math.round(a / u) + 1;
}
export {
  p as default
};
